import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import {
  getHbEarnHistory,
  resetEarningHistory,
} from 'hb-redux-store/feature/halalboxPoints/hbPoint.action';
import {
  RUPEE_SYMBOL,
  DEVICE_TYPE,
  POINTS_FILTER,
} from 'hb-redux-store/util/constantServices';
import { getDeviceType } from 'hb-redux-store/util/DeviceDetectionService';
import { showEarningHistoryModal } from 'hb-redux-store/feature/modal/modal.action';

import './earning-history.scss';

import SecondaryNav from 'components/mweb/SecondaryNav/SecondaryNav';
import Messages from 'components/mweb/Messages/Messages';
import Loader from 'components/mweb/Skeletons/Loader/Loader';
import Button from 'components/common/Button/Button';
import Drawer from 'components/common/Drawer';

import earnCoin from 'assets/icons/earncoin.svg';
import EarnHistoryItems from 'components/mweb/HalalboxPoints/EarnHistoryItems';
import Icon from 'components/mweb/Icon/Icon';

// CONSTANT
const AVAILABLE_POINTS = 'Available VXL Points ';
const HALAL_BOX_POINTS = 'VXL Points';
const pageSize = 10;
const LOAD_MORE = 'Load More';
const PENDING_EMPTY_DATA_TEXT = [
  'No pending invitation found',
  'Hurry, start referring and start earning',
];
const EARN_EMPTY_DATA_TEXT = [
  'You have not earned any vegxl points yet',
  'Hurry, start shopping and start earning',
];

export const RenderHistory = ({ history = [] }) => {
  return (
    <>
      {history.map((item, index) => (
        <EarnHistoryItems key={item?.title + index} item={item} />
      ))}
    </>
  );
};

const EarningHistory = props => {
  const {
    getHbEarnHistory,
    loading,
    hbPointEarnHistory,
    resetEarningHistory,
    earningHistory,
    earningHistoryModal,
    showEarningHistoryModal,
  } = props;
  const balancePoint = hbPointEarnHistory?.hbPointsBalance || 0;
  const halaboxPointsText =
    hbPointEarnHistory?.hbPointsTitle || HALAL_BOX_POINTS;
  const halaboxPoints = `${halaboxPointsText}${' '}${balancePoint}`;
  const [activeTab, setActiveTab] = useState(POINTS_FILTER[0]);
  const [pageNo, setPageNo] = React.useState(0);
  const isMobileDevice = getDeviceType() === DEVICE_TYPE.MWEB;
  useEffect(() => {
    getHbEarnHistory({ tab: activeTab?.value, pageNo, pageSize });
  }, [pageNo, activeTab]);

  const handleCategoryData = tab => {
    resetEarningHistory();
    setActiveTab(tab);
    setPageNo(0);
  };

  const HistoryComponent = () => (
    <div className="hb-point--bg">
      <div className="hb-point--earnBalance">
        <Messages
          message={halaboxPoints}
          webClassName="hb-point--earnHistory"
          icon={earnCoin}
        />
      </div>
      <div className="hb-point--categories">
        {POINTS_FILTER.map((tab, index) => (
          <div
            className={`hb-point--categories--category ${
              activeTab?.pid === index ? 'active' : ''
            }`}
            key={tab.pid}
            onClick={() => handleCategoryData(tab, index)}
          >
            {tab.title}
          </div>
        ))}
      </div>
      {!hbPointEarnHistory?.earn && !earningHistory.length && !loading && (
        <div className="hb-point--data-not-found-container">
          <Icon class="icon-cart-empty-cart" size={200} />
          <div className="hb-point--emptyContainer">
            <div className="hb-point--data-not-found-text">
              {activeTab?.value === 'all'
                ? EARN_EMPTY_DATA_TEXT[0]
                : PENDING_EMPTY_DATA_TEXT[0]}
            </div>
            <div className="hb-point--data-not-found-text">
              {activeTab?.value === 'all'
                ? EARN_EMPTY_DATA_TEXT[1]
                : PENDING_EMPTY_DATA_TEXT[1]}
            </div>
          </div>
        </div>
      )}
      {earningHistory && (
        <div className="hb-point--listItems">
          <RenderHistory history={earningHistory} />
        </div>
      )}
      {hbPointEarnHistory?.earn?.length === pageSize && !loading && (
        <div className="hb-money--transactions--view-more hb-point--btn-container">
          <Button
            className="button button-ghost full-width large"
            onClick={() => {
              setPageNo(pageNo + 1);
            }}
            disabled={loading}
          >
            {LOAD_MORE}
          </Button>
        </div>
      )}
      <div className="hb-point--emptyContainer"></div>
    </div>
  );

  return (
    <div className="hb-point">
      {loading && pageNo === 0 && <Loader />}
      {isMobileDevice ? (
        <>
          <SecondaryNav
            title={HALAL_BOX_POINTS}
            capitalize
            showCart={false}
            showSearch={false}
          />
          <HistoryComponent />
        </>
      ) : (
        <Drawer
          title="EARNING HISTORY"
          placement="right"
          closable={true}
          onClose={() => showEarningHistoryModal(false)}
          visible={earningHistoryModal}
          destroyOnClose={true}
          maskClosable={true}
          width={500}
        >
          <HistoryComponent />
        </Drawer>
      )}
    </div>
  );
};

const mapStateToProps = ({ hbPointReducer, modalReducer }) => ({
  hbPointEarnHistory: hbPointReducer.hbPointEarnHistory,
  earningHistory: hbPointReducer.earningHistory,
  loading: hbPointReducer.loading,
  earningHistoryModal: modalReducer.earningHistoryModal,
});

const mapDispatchToProps = {
  getHbEarnHistory,
  resetEarningHistory,
  showEarningHistoryModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(EarningHistory);
